// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app-notifications-wrapper{display:flex;flex-direction:column}.app-notifications-wrapper__transition-container{padding:0;position:relative}.app-notifications-wrapper__notification{width:100%}.app-notifications-wrapper__notification:not(:first-child){margin:var(--spacing-smaller) 0 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
